<template>
  <section>
    <v-list two-line style="background: transparent;">
      <div class="section-box section-box-list"
        v-for="(message, index) in messages" :key="index"
        v-bind:class="{ 'is-admin': false && message.user.roles.indexOf('admin') !== -1  }" v-if="message.comment && message.comment.length">
        <v-list-tile :key="message.title">
          <v-list-tile-avatar>
            <v-avatar size="32" color="deep-orange darken-2">
              <img :src="message.user.avatar" height="32" v-if="message.user.avatar">
              <v-icon color="white" v-else>fal fa-user-circle</v-icon>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>{{ message.user.first_name }}</strong> -
              <v-tooltip bottom>
                <span slot="activator">{{ message.updated_at | moment('from', 'now') }}</span>
                <span>{{ message.updated_at | moment('DD/MM/Y, HH:mm') }}</span>
              </v-tooltip>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <div class="mx-4 my-3 message">{{ message.comment }}</div>
      </div>
    </v-list>

    <v-flex xs12 class="my-3">
      <v-textarea v-model="newMessage.comment" placeholder="Escreva algo...." outline
        rows="6" auto-grow required hide-details></v-textarea>
    </v-flex>

    <v-card-actions>
      <router-link class="simple-gray-link"
        :to="{ path: '/support'}">
        <v-icon small>fal fa-chevron-left</v-icon>
        Voltar
      </router-link>

      <v-spacer></v-spacer>
      <v-btn @click.stop="sendMessage()" round large depressed color="success"
        :loading="loadingRequest">
        RESPONDER
      </v-btn>
    </v-card-actions>
  </section>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
const currentUser = JSON.parse(localStorage.getItem('currentUser'))

export default {
  data: () => ({
    newMessage: {
      comment: '',
      user: currentUser._id
    },
    loadingRequest: false
  }),

  methods: {
    sendMessage () {
      this.loadingRequest = true

      // eslint-disable-next-line
      axios.post(API.userTicketsAnswers + '/tickets/' + this.$route.params.id, this.newMessage).then(response => {
        EventBus.$emit('appLoading', false)
        EventBus.$emit('loadAnswers')
        EventBus.$emit('updateTicket')
        this.loadingRequest = false
        this.newMessage.comment = ''
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar as mensagens',
          color: 'error'
        })
        this.loadingRequest = false
        EventBus.$emit('appLoading', false)
      })
    }
  },

  props: ['messages']
}
</script>

<style scoped>
  .section-box-list {
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: none;
  }

  .section-box-list.is-admin {
    border: 0;
    background: rgba(0, 0, 0, 0.05);
  }

  .section-box-list .message {
    margin-top: -10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/support/AdminTicketShowMessages.vue